/* PilotstoriesArt theme: shared behaviour (vanilla, no build step).
   Mirrors the design-system React components in design-reference/handoff/ds-components:
   Dialog (psa-dlg--in after 20 ms, unmount after 380 ms, Escape, scrim), Accordion, Tabs, QuantityStepper, Toast (4 s).
   Also: AJAX cart with the Section Rendering API, cart badge, email validation, cookie-settings link, EN/DE switch. */
(function () {
  'use strict';

  var html = document.documentElement;
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  var openStack = [];

  /* ---------- Dialog ---------- */
  function dialogById(id) { return document.getElementById(id); }

  // While a dialog is open everything outside it is inert, so Tab cannot leave it (Safari tabs only to buttons and fields, so
  // the trap below alone let focus out; review 9 Oct 2026, finding 8). Recomputed for the top dialog on every open and close.
  function updateInert() {
    document.querySelectorAll('[data-psa-inert]').forEach(function (e) { e.inert = false; e.removeAttribute('data-psa-inert'); });
    var top = openStack[openStack.length - 1];
    for (var n = top; n && n.parentElement && n !== document.body; n = n.parentElement) {
      Array.prototype.forEach.call(n.parentElement.children, function (s) {
        // the toasts and their live regions stay usable: a cart error inside the drawer must still be read and closed
        if (s !== n && !s.inert && s.tagName !== 'SCRIPT' && s.tagName !== 'STYLE' && s.id !== 'PsaToasts' && !s.hasAttribute('data-psa-live')) { s.inert = true; s.setAttribute('data-psa-inert', ''); }
      });
    }
  }

  function openDialog(dlg, opener) {
    if (!dlg || !dlg.hasAttribute('hidden')) return;
    clearTimeout(dlg._psaT);
    dlg._psaOpener = opener || document.activeElement;
    dlg.removeAttribute('hidden');
    openStack.push(dlg);
    updateInert();
    html.classList.add('psa-lock');
    setExpanded(dlg.id, true);
    dlg._psaT = setTimeout(function () {
      dlg.classList.add('psa-dlg--in');
      var panel = dlg.querySelector('.psa-dlg__panel');
      if (panel) panel.focus({ preventScroll: true });
    }, 20);
    dlg.dispatchEvent(new CustomEvent('psa:dialog-open', { bubbles: true }));
  }

  function closeDialog(dlg) {
    if (!dlg || dlg.hasAttribute('hidden')) return;
    clearTimeout(dlg._psaT);
    dlg.classList.remove('psa-dlg--in');
    openStack = openStack.filter(function (d) { return d !== dlg; });
    updateInert();
    setExpanded(dlg.id, false);
    dlg._psaT = setTimeout(function () {
      dlg.setAttribute('hidden', '');
      if (!openStack.length) html.classList.remove('psa-lock');
      var o = dlg._psaOpener;
      if (o && document.contains(o) && o.focus) o.focus({ preventScroll: true });
    }, 380);
    dlg.dispatchEvent(new CustomEvent('psa:dialog-close', { bubbles: true }));
  }

  function setExpanded(id, on) {
    document.querySelectorAll('[aria-controls="' + id + '"][aria-expanded]').forEach(function (b) {
      b.setAttribute('aria-expanded', on ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-psa-open]');
    if (opener) {
      if (opener.hasAttribute('data-psa-cart-toggle') && document.body.getAttribute('data-template') === 'cart') return;
      var dlg = dialogById(opener.getAttribute('data-psa-open'));
      if (dlg) { e.preventDefault(); openDialog(dlg, opener); }
      return;
    }
    var closer = e.target.closest('[data-psa-close]');
    if (closer) {
      var d = closer.closest('[data-psa-dialog]');
      if (d) { e.preventDefault(); closeDialog(d); }
    }
  });

  window.psaOpenDialog = openDialog;
  window.psaCloseDialog = closeDialog;

  document.addEventListener('keydown', function (e) {
    var top = openStack[openStack.length - 1];
    if (!top) return;
    if (e.key === 'Escape') { closeDialog(top); return; }
    if (e.key === 'Tab') {
      // Tab and Shift+Tab cycle through the dialog's controls in every browser (Safari's own Tab skips links, so it left the
      // dialog from its last button); roving radios (tabindex -1) and inert parts are left out.
      var items = Array.prototype.filter.call(top.querySelectorAll(FOCUSABLE), function (el) {
        return el.offsetParent !== null && el.getAttribute('tabindex') !== '-1' && !el.closest('[inert]');
      });
      if (!items.length) return;
      e.preventDefault();
      var i = items.indexOf(document.activeElement);
      var next = e.shiftKey ? (i <= 0 ? items.length - 1 : i - 1) : (i < 0 || i === items.length - 1 ? 0 : i + 1);
      items[next].focus();
    }
  });

  /* ---------- Keyboard focus never lands under the sticky header or the bars at the bottom (cookie bar, phone buy bar,
     newsletter box): WCAG 2.4.11, review 9 Oct 2026, finding 7. Only focus moves are corrected, so the in-page anchors keep
     their own scroll-margin-top. ---------- */
  var CHROME = '.psa-header-wrap,[data-psa-cookie-bar],[data-psa-atc-bar],.psa-nlbox,#PsaToasts,[data-psa-dialog]';
  document.addEventListener('focusin', function (e) {
    var t = e.target;
    if (!t || !t.closest || t.closest(CHROME) || openStack.length) return;
    // checked on the next frame and again a moment later: the buy bar may appear, or Safari may scroll, after the focus move
    requestAnimationFrame(clear);
    setTimeout(clear, 250);
    function clear() {
      if (document.activeElement !== t || !t.matches(':focus-visible')) return; // keyboard focus only, never a mouse click
      var r = t.getBoundingClientRect();
      if (!r.height) return;
      var hdr = document.querySelector('.psa-header-wrap'), top = hdr ? Math.max(0, hdr.getBoundingClientRect().bottom) : 0, bottom = window.innerHeight;
      // the bars can stack (the buy bar sits on top of the cookie bar), so the highest one counts
      document.querySelectorAll('[data-psa-cookie-bar]:not([hidden]),[data-psa-atc-bar]:not([hidden]),.psa-nlbox').forEach(function (b) {
        var br = b.getBoundingClientRect();
        if (br.height && br.top < bottom && br.top > window.innerHeight * 0.4) bottom = br.top;
      });
      if (r.top < top + 4) window.scrollBy({ top: r.top - top - 16, behavior: 'instant' });
      else if (r.bottom > bottom - 4) window.scrollBy({ top: r.bottom - bottom + 16, behavior: 'instant' });
    }
  });

  /* ---------- Accordion ---------- */
  document.addEventListener('click', function (e) {
    var head = e.target.closest('.psa-acc__head');
    if (!head) return;
    var item = head.closest('.psa-acc__item');
    var acc = head.closest('.psa-acc');
    var willOpen = !item.classList.contains('psa-acc__item--open');
    if (acc && !acc.hasAttribute('data-multiple')) {
      acc.querySelectorAll('.psa-acc__item--open').forEach(function (it) { if (it !== item) setAcc(it, false); });
    }
    setAcc(item, willOpen);
  });
  function setAcc(item, on) {
    item.classList.toggle('psa-acc__item--open', on);
    var h = item.querySelector('.psa-acc__head');
    var inner = item.querySelector('.psa-acc__inner');
    if (h) h.setAttribute('aria-expanded', on ? 'true' : 'false');
    if (inner) { if (on) inner.removeAttribute('inert'); else inner.setAttribute('inert', ''); }
  }
  window.psaOpenAccordion = function (id) {
    var h = document.getElementById(id + '-h');
    if (h) { var it = h.closest('.psa-acc__item'); if (!it.classList.contains('psa-acc__item--open')) h.click(); }
  };

  /* ---------- Tabs (role=tablist). Buttons may point at panels with aria-controls; a "psa:tab" event carries the value. ---------- */
  function selectTab(tab) {
    var list = tab.closest('[role="tablist"]');
    if (!list) return;
    list.querySelectorAll('[role="tab"]').forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.setAttribute('tabindex', on ? '0' : '-1');
      var pid = t.getAttribute('aria-controls');
      if (pid) { var p = document.getElementById(pid); if (p) { if (on) p.removeAttribute('hidden'); else p.setAttribute('hidden', ''); } }
    });
    list.dispatchEvent(new CustomEvent('psa:tab', { bubbles: true, detail: { value: tab.getAttribute('data-value'), tab: tab } }));
  }
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[role="tab"]');
    if (!tab || tab.tagName === 'A') return;
    selectTab(tab);
  });
  document.addEventListener('keydown', function (e) {
    var tab = e.target.closest && e.target.closest('[role="tab"]');
    if (!tab) return;
    var tabs = Array.prototype.slice.call(tab.closest('[role="tablist"]').querySelectorAll('[role="tab"]'));
    var i = tabs.indexOf(tab), j = null;
    if (e.key === 'ArrowRight') j = (i + 1) % tabs.length;
    if (e.key === 'ArrowLeft') j = (i - 1 + tabs.length) % tabs.length;
    if (e.key === 'Home') j = 0;
    if (e.key === 'End') j = tabs.length - 1;
    if (j === null) return;
    e.preventDefault();
    if (tabs[j].tagName === 'A') { tabs[j].focus(); return; }
    selectTab(tabs[j]);
    tabs[j].focus();
  });
  window.psaSelectTab = selectTab;

  /* ---------- Quantity stepper ---------- */
  function setQty(box, v) {
    var min = parseInt(box.getAttribute('data-min') || '1', 10);
    var max = parseInt(box.getAttribute('data-max') || '99', 10);
    v = Math.max(min, Math.min(max, v));
    var out = box.querySelector('.psa-qty__val');
    var cur = parseInt(out.textContent, 10);
    if (v === cur) return;
    out.textContent = v;
    var inp = box.querySelector('[data-psa-qty-input]');
    if (inp) inp.value = v;
    box.querySelector('[data-psa-qty-dec]').disabled = v <= min;
    box.querySelector('[data-psa-qty-inc]').disabled = v >= max;
    box.dispatchEvent(new CustomEvent('psa:qty', { bubbles: true, detail: { value: v } }));
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-psa-qty-dec],[data-psa-qty-inc]');
    if (!b) return;
    var box = b.closest('[data-psa-qty]');
    var cur = parseInt(box.querySelector('.psa-qty__val').textContent, 10) || 1;
    setQty(box, cur + (b.hasAttribute('data-psa-qty-inc') ? 1 : -1));
  });
  window.psaSetQty = setQty;

  /* ---------- Toast ---------- */
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  // Announcements go through two live regions that exist before any toast (review 9 Oct 2026, finding 9): a region inserted
  // together with its text is read out by some screen readers and not by others. They stay usable while a dialog is open.
  var live = {};
  ['status', 'alert'].forEach(function (role) {
    var r = document.createElement('div');
    r.className = 'psa-sr';
    r.setAttribute('role', role);
    r.setAttribute('data-psa-live', '');
    document.body.appendChild(r);
    live[role] = r;
  });
  function announce(role, text) {
    var r = live[role];
    r.textContent = '';
    setTimeout(function () { r.textContent = text; }, 60);
  }
  function toast(o) {
    var host = document.getElementById('PsaToasts');
    if (!host) return;
    host.innerHTML = '';
    var tone = o.tone && o.tone !== 'default' ? ' psa-toast--' + o.tone : '';
    var el = document.createElement('div');
    el.className = 'psa-toast' + tone;
    announce(o.tone === 'danger' ? 'alert' : 'status', [o.title, o.message].filter(Boolean).join('. '));
    el.innerHTML = (o.image ? '<img class="psa-toast__thumb" src="' + esc(o.image) + '" alt="">' : '<span class="psa-toast__marker" aria-hidden="true"></span>') +
      '<div class="psa-toast__body">' + (o.title ? '<span class="psa-toast__title">' + esc(o.title) + '</span>' : '') +
      (o.message ? '<span class="psa-toast__msg">' + esc(o.message) + '</span>' : '') +
      (o.action ? '<button type="button" class="psa-toast__action" data-psa-open="' + esc(o.action.open) + '">' + esc(o.action.label) + '</button>' : '') + '</div>' +
      '<button type="button" class="psa-toast__close" aria-label="' + esc(window.PSA_I18N && PSA_I18N.dismiss || 'Dismiss') + '">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="miter" aria-hidden="true" focusable="false" style="display:block;flex:none"><path d="M18 6 6 18"/> <path d="m6 6 12 12"/></svg></button>';
    host.appendChild(el);
    // Errors stay until closed; other toasts pause while hovered or focused and run their full time again afterwards.
    var t = 0, ms = o.duration || 4000;
    function start() { clearTimeout(t); if (o.tone !== 'danger') t = setTimeout(function () { el.remove(); }, ms); }
    el.addEventListener('mouseenter', function () { clearTimeout(t); });
    el.addEventListener('focusin', function () { clearTimeout(t); });
    el.addEventListener('mouseleave', function () { if (!el.contains(document.activeElement)) start(); });
    el.addEventListener('focusout', function (e) { if (!el.contains(e.relatedTarget) && !el.matches(':hover')) start(); });
    start();
    el.querySelector('.psa-toast__close').addEventListener('click', function () { clearTimeout(t); el.remove(); });
    var act = el.querySelector('.psa-toast__action');
    if (act) act.addEventListener('click', function () { clearTimeout(t); setTimeout(function () { el.remove(); }, 50); });
  }
  window.psaToast = toast;

  /* ---------- Cart ---------- */
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function updateBadges(count) {
    document.querySelectorAll('[data-psa-cart-toggle]').forEach(function (a) {
      var label = a.getAttribute('title') || 'Cart';
      a.setAttribute('aria-label', count ? label + ' (' + count + ')' : label);
      var b = a.querySelector('.psa-iconbtn__badge');
      if (count) {
        if (!b) { b = document.createElement('span'); b.className = 'psa-iconbtn__badge'; a.appendChild(b); }
        b.textContent = count;
      } else if (b) { b.remove(); }
    });
  }

  function swapDrawer(sectionHtml) {
    if (!sectionHtml) return;
    var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var fresh = doc.querySelector('#PsaCart .psa-dlg__panel');
    var cur = document.querySelector('#PsaCart .psa-dlg__panel');
    if (fresh && cur) cur.innerHTML = fresh.innerHTML;
  }

  function cartRequest(url, body) {
    return fetch(root + url, {
      method: 'POST',
      headers: body instanceof FormData ? { Accept: 'application/json' } : { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body instanceof FormData ? body : JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) { var er = new Error(j.description || j.message || 'Error'); er.data = j; throw er; } return j; }); });
  }

  // Cart errors say what did not happen and what to do (review 9 Oct 2026, finding 5): Shopify's own reason when it sends one
  // ("All 1 … are in your cart."), otherwise, as when the connection drops, the plain next step.
  function cartError(titleKey, err) {
    var i = window.PSA_I18N || {};
    var msg = err && err.data && err.message ? err.message : (i.error_network || 'Check your connection and try again.');
    toast({ tone: 'danger', title: i[titleKey] || i.error, message: msg });
  }

  function refreshCount() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { updateBadges(c.item_count); return c; });
  }

  function changeLine(key, qty) {
    var drawer = document.getElementById('PsaCart');
    if (drawer) drawer.style.cursor = 'progress';
    return cartRequest('cart/change.js', { id: key, quantity: qty, sections: 'psa-cart-drawer', sections_url: window.location.pathname })
      .then(function (c) {
        updateBadges(c.item_count);
        swapDrawer(c.sections && c.sections['psa-cart-drawer']);
        if (document.body.getAttribute('data-template') === 'cart') window.location.reload();
      })
      .catch(function (err) { cartError('error_update', err); })
      .finally(function () { if (drawer) drawer.style.cursor = ''; });
  }

  // Language switch (snippets/psa-language-switch.liquid): whoever picks English on purpose doesn't get the German hint
  // again during this visit (sections/psa-header.liquid; German version, docs/german.md).
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-psa-lang]');
    if (a && a.getAttribute('data-psa-lang') !== 'de') { try { window.sessionStorage.setItem('psa-lang-hint', 'closed'); } catch (err) {} }
  });

  // Review email tick box in the cart (snippets/psa-cart-content.liquid): saved at once as the cart attribute "Review email",
  // so the drawer and the cart page agree; the order carries it to the review email routine (marketing/reviews.md).
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-psa-review-optin]')) return;
    cartRequest('cart/update.js', { attributes: { 'Review email': e.target.checked ? 'yes' : '' } }).catch(function () {});
  });

  document.addEventListener('psa:qty', function (e) {
    var box = e.target.closest('[data-psa-line-qty]');
    if (!box) return;
    changeLine(box.getAttribute('data-psa-line-qty'), e.detail.value);
  });
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-psa-line-remove]');
    if (!rm) return;
    e.preventDefault();
    changeLine(rm.getAttribute('data-psa-line-remove'), 0);
  });

  /* Product forms: <form data-psa-add> with name="id" and quantity. */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-psa-add]');
    if (!form) return;
    e.preventDefault();
    var btns = Array.prototype.slice.call(form.querySelectorAll('[type="submit"]')).concat(form.id ? Array.prototype.slice.call(document.querySelectorAll('[form="' + form.id + '"][type="submit"]')) : []);
    btns.forEach(function (b) { b.setAttribute('aria-disabled', 'true'); });
    var fd = new FormData(form);
    fd.append('sections', 'psa-cart-drawer');
    fd.append('sections_url', window.location.pathname);
    cartRequest('cart/add.js', fd).then(function (item) {
      swapDrawer(item.sections && item.sections['psa-cart-drawer']);
      return refreshCount().then(function () {
        var row = document.querySelector('#PsaCart [data-psa-line="' + (item.key || '') + '"]');
        var metaEl = row && row.querySelector('[data-psa-line-meta]'), titleEl = row && row.querySelector('[data-psa-line-title]'), imgEl = row && row.querySelector('img');
        var meta = row && row.getAttribute('data-psa-toast-meta') ? row.getAttribute('data-psa-toast-meta') : (metaEl ? metaEl.textContent.trim() : (item.variant_title || ''));
        var qty = parseInt(fd.get('quantity') || '1', 10);
        var title = titleEl ? titleEl.textContent.trim() : (item.product_title || item.title);
        var img = imgEl ? (imgEl.currentSrc || imgEl.src) : (item.image || '');
        toast({ tone: 'success', title: (window.PSA_I18N && PSA_I18N.added) || 'Added to cart', message: title + (meta ? ' · ' + meta : '') + (qty > 1 ? ' · ×' + qty : ''), image: img, duration: 6000, action: { label: (window.PSA_I18N && PSA_I18N.view_cart) || 'View cart', open: 'PsaCart' } });
        form.dispatchEvent(new CustomEvent('psa:added', { bubbles: true, detail: item }));
      });
    }).catch(function (err) {
      cartError('error_add', err);
    }).finally(function () {
      btns.forEach(function (b) { b.removeAttribute('aria-disabled'); });
    });
  });

  /* ---------- Email validation (newsletter, password page): design rule /.+@.+\..+/ ---------- */
  document.addEventListener('submit', function (e) {
    var box = e.target.querySelector && e.target.querySelector('[data-psa-email-form]');
    if (!box) return;
    var input = box.querySelector('input[type="email"]');
    if (!input) return;
    if (/.+@.+\..+/.test(input.value.trim())) return;
    e.preventDefault();
    showFieldError(input, box.getAttribute('data-error'));
    input.focus();
  }, true);

  function showFieldError(input, msg) {
    var field = input.closest('[data-psa-field]');
    if (!field) return;
    var cls = field.classList.contains('psa-sel') ? 'psa-sel--error' : 'psa-field--error';
    field.classList.add(cls);
    input.setAttribute('aria-invalid', 'true');
    var id = input.id + '-msg';
    input.setAttribute('aria-describedby', id);
    var span = document.getElementById(id);
    if (!span) { span = document.createElement('span'); span.id = id; field.appendChild(span); }
    if (cls === 'psa-sel--error') { span.className = 'psa-sel__error'; span.textContent = msg; }
    else {
      span.className = 'psa-field__error';
      span.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="miter" aria-hidden="true" focusable="false" style="display:block;flex:none"><circle cx="12" cy="12" r="10"/> <line x1="12" x2="12" y1="8" y2="12"/> <line x1="12" x2="12.01" y1="16" y2="16"/></svg>';
      span.appendChild(document.createTextNode(msg));
    }
  }
  function clearFieldError(input) {
    var field = input.closest('[data-psa-field]');
    if (!field) return;
    field.classList.remove('psa-field--error', 'psa-sel--error');
    input.removeAttribute('aria-invalid');
    var span = document.getElementById(input.id + '-msg');
    if (span && (span.classList.contains('psa-field__error') || span.classList.contains('psa-sel__error'))) {
      var hint = input.getAttribute('data-hint');
      if (hint) { span.className = 'psa-field__hint'; span.textContent = hint; } else { span.remove(); input.removeAttribute('aria-describedby'); }
    }
  }
  document.addEventListener('input', function (e) { if (e.target.matches && e.target.matches('[aria-invalid="true"]')) clearFieldError(e.target); });
  document.addEventListener('change', function (e) { if (e.target.matches && e.target.matches('[aria-invalid="true"]')) clearFieldError(e.target); });
  window.psaShowFieldError = showFieldError;
  window.psaClearFieldError = clearFieldError;

  /* ---------- Cookie settings link ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-psa-cookie-settings]');
    if (!a) return;
    var own = document.getElementById('PsaCookieDialog');
    if (own) { e.preventDefault(); openDialog(own, a); return; }
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') { e.preventDefault(); window.privacyBanner.showPreferences(); }
  });

  /* ---------- Newsletter: sending to Brevo (footer, newsletter page, box) and the newsletter box ----------
     "psa-nl" = 'closed' | 'in' | 'email'. Kept for the visit after the visitor's own click (sessionStorage); 30 days after
     closing and for good after signing up only with marketing consent (localStorage, psa-consent.js removes it when that
     consent is withdrawn). Privacy policy: "Cookies and consent". */
  var NL = 'psa-nl';
  function nlConsent() { return ((window.psaConsent && window.psaConsent()) || {}).marketing; }
  function nlMark(state) {
    try { sessionStorage.setItem(NL, state); } catch (e) {}
    if (nlConsent() === 'yes') try { localStorage.setItem(NL, JSON.stringify({ s: state, t: Date.now() })); } catch (e) {}
  }
  function nlQuiet(days) {
    var s = null, l = null, m = nlConsent();
    try { s = sessionStorage.getItem(NL); } catch (e) {}
    try { l = JSON.parse(localStorage.getItem(NL) || 'null'); } catch (e) {}
    if (m !== 'yes') l = null;
    else if (s && s !== 'email' && !l) nlMark(s); // a click made before the consent was known
    return !!s || !!(l && (l.s === 'in' || Date.now() - l.t < days * 864e5));
  }
  window.psaBrevoSend = function (form) {
    return fetch(form.action + '?isAjax=1', { method: 'POST', body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function (d) { if (!d || !d.success) throw new Error('rejected'); nlMark('in'); return d; });
  };
  // Back from Brevo's confirmation link, or here with a discount code or from an email: no box on this visit.
  if (/[?&]confirmed(=|&|$)/.test(location.search) && document.getElementById('PsaNlPage')) nlMark('in');
  else if (/[?&]utm_medium=email/i.test(location.search) || /(^|;\s*)discount_code=/.test(document.cookie)) {
    try { sessionStorage.setItem(NL, 'email'); } catch (e) {}
  }

  var nlTpl = document.getElementById('PsaNlBoxTpl');
  if (nlTpl) {
    var nlPart = (parseInt(nlTpl.getAttribute('data-scroll'), 10) || 50) / 100;
    var nlNeed = parseInt(nlTpl.getAttribute('data-delay'), 10) || 20;
    var nlDays = parseInt(nlTpl.getAttribute('data-days'), 10) || 30;
    var nlSecs = 0, nlDeep = false, nlFoot = false;
    // The footer's form or the one under a story is on screen: the box waits.
    var nlSeen = {};
    ['PsaNewsletter', 'PsaStoryNl'].forEach(function (id) {
      var f = document.getElementById(id);
      if (f && 'IntersectionObserver' in window) new IntersectionObserver(function (en) { nlSeen[id] = en[0].isIntersecting; nlFoot = !!(nlSeen.PsaNewsletter || nlSeen.PsaStoryNl); }).observe(f);
    });
    var nlTick = setInterval(function () {
      var bar = document.querySelector('[data-psa-cookie-bar]');
      if (document.hidden || (bar && !bar.hidden) || html.classList.contains('psa-lock')) return;
      if (!nlDeep) nlDeep = window.scrollY + window.innerHeight >= document.documentElement.scrollHeight * nlPart;
      if (++nlSecs < nlNeed || !nlDeep || nlFoot || document.querySelector('[data-psa-cart-toggle] .psa-iconbtn__badge')) return;
      clearInterval(nlTick);
      if (!nlQuiet(nlDays)) showNlBox();
    }, 1000);
  }

  function showNlBox() {
    var main = document.getElementById('MainContent');
    var box = nlTpl.content.firstElementChild.cloneNode(true);
    if (main) main.after(box); else document.body.appendChild(box);
    var form = box.querySelector('[data-psa-nlbox-form]'), ok = box.querySelector('[data-psa-nlbox-ok]');
    var input = form.querySelector('input[type="email"]'), btn = form.querySelector('[type="submit"]'), x = box.querySelector('[data-psa-nlbox-close]');
    // WCAG 2.4.11: the page scrolls a focused link above the box, never behind it.
    function pad() { html.style.scrollPaddingBottom = Math.max(0, window.innerHeight - box.getBoundingClientRect().top + 8) + 'px'; }
    function esc(e) { if (e.key === 'Escape' && !html.classList.contains('psa-lock')) close(); }
    function close() {
      var focused = box.contains(document.activeElement);
      if (!form.hidden) nlMark('closed');
      box.remove();
      html.style.scrollPaddingBottom = '';
      window.removeEventListener('resize', pad);
      document.removeEventListener('keydown', esc);
      if (focused && main) main.focus({ preventScroll: true });
    }
    pad();
    window.addEventListener('resize', pad);
    document.addEventListener('keydown', esc);
    x.addEventListener('click', close);
    form.addEventListener('submit', function (e) {
      if (e.defaultPrevented) return; // the email check above showed its message
      e.preventDefault();
      if (btn.hasAttribute('aria-disabled')) return;
      btn.setAttribute('aria-disabled', 'true');
      window.psaBrevoSend(form).then(function () {
        form.hidden = true;
        ok.hidden = false;
        x.querySelector('[data-psa-nlbox-decline]').hidden = true;
        x.setAttribute('aria-label', (window.PSA_I18N && PSA_I18N.dismiss) || 'Dismiss');
        ok.querySelector('[tabindex]').focus({ preventScroll: true });
        pad();
      }).catch(function () {
        var eb = form.querySelector('[data-psa-email-form]');
        showFieldError(input, eb.getAttribute('data-send-error') || eb.getAttribute('data-error'));
      }).then(function () { btn.removeAttribute('aria-disabled'); });
    });
  }

})();

/* After a review is sent (Shopify redirects to ?contact_posted=true#PsaReviewForm), scroll to the reviews and their thank-you line. */
document.addEventListener('DOMContentLoaded', function () {
  if (window.location.hash === '#PsaReviewForm' && /contact_posted=true/.test(window.location.search)) {
    var r = document.getElementById('reviews');
    if (r) r.scrollIntoView();
  }
  /* The review request email (emails/review-request.html) links to <product>#write-review: open the "Write a review" form. */
  if (window.location.hash === '#write-review') {
    var w = document.querySelector('[data-psa-open="PsaReviewDialog"]');
    if (w) w.click();
  }
});

/* Optical left edge of big type: snippets/psa-optical-js.liquid (inline in <head>, so a section can run it before the first paint). */
if (window.psaOptical) window.psaOptical(document);
